import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo_fenasu.png";
import { UserContext } from "../../UserContext";

/* =======================
   COMPOSANT PRINCIPAL
======================= */
const Fenmenu = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const permissions = user?.permission_ids || [];

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  /* ===== NAVIGATION ===== */
  const handleMenuprincipal = () => navigate("/dashboard");
  const handleBraiders = () => navigate("/empc");
  const handlecltstraking = () => navigate("/fentb");

  /* ===== LOGOUT ===== */
  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setLogoutLoading(true);

    setTimeout(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.clear();

      setUser(null);

      navigate("/login", { replace: true });
    }, 800);
  };

  const cancelLogout = () => {
    if (logoutLoading) return;
    setShowLogoutConfirm(false);
  };

  return (
    <div style={styles.pageBackground}>
      {/* Bandeau */}
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716
          </span>
        </marquee>
      </div>

      {/* Carte principale */}
      <div style={styles.card}>
        {/* Logo */}
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="logo"
            style={{ width: "150px", marginBottom: "20px" }}
          />
          <h2>Menu Principal</h2>
        </div>

        {/* Boutons */}
        <div style={styles.buttonContainerVertical}>
          <AnimatedButton
            color="#007bff"
            onClick={handlecltstraking}
            disabled={!permissions.includes(33)}
          >
            Client operations tracking
          </AnimatedButton>

          <AnimatedButton
            color="#dc3545"
            onClick={handleBraiders}
            disabled={!permissions.includes(2)}
          >
            Braiders tracking
          </AnimatedButton>

          <AnimatedButton
            color="#28a745"
            onClick={handleMenuprincipal}
            disabled={!permissions.includes(3)}
          >
            Menu Principal
          </AnimatedButton>

          {/* DÉCONNEXION */}
          <AnimatedButton color="#000000" onClick={handleLogout}>
            🔒 Deconnexion
          </AnimatedButton>
        </div>
      </div>

      {/* MODAL CONFIRMATION LOGOUT */}
      {showLogoutConfirm && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <h3 style={{ marginBottom: "20px" }}>Confirmation</h3>

            <p style={{ fontSize: "1.1rem", marginBottom: "30px" }}>
              Are you sure you want to log out?
            </p>

            <div style={modalStyles.actions}>
              <button
                onClick={cancelLogout}
                disabled={logoutLoading}
                style={modalStyles.cancelBtn}
              >
                Cancel
              </button>

              <button
                onClick={confirmLogout}
                disabled={logoutLoading}
                style={modalStyles.confirmBtn}
              >
                {logoutLoading ? "Deconnexion..." : "Yes, se déconnecter"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* =======================
   BOUTON ANIMÉ
======================= */
const AnimatedButton = ({ color, onClick, children, disabled = false }) => {
  return (
    <button
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      style={{
        ...styles.button,
        background: `linear-gradient(90deg, ${color} 0%, #ffffff 100%)`,
        color: "#fff",
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = "scale(1.05) rotate(-1deg)";
        e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.35)";
        e.currentTarget.style.background = `linear-gradient(90deg, ${color} 0%, #6a11cb 100%)`;
      }}
      onMouseLeave={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = "scale(1) rotate(0deg)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.25)";
        e.currentTarget.style.background = `linear-gradient(90deg, ${color} 0%, #ffffff 100%)`;
      }}
    >
      {children}
    </button>
  );
};

/* =======================
   STYLES
======================= */
const styles = {
  pageBackground: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f9f9f9 0%, #e6ecff 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    paddingBottom: "40px",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "10px 0",
    width: "100%",
    borderBottom: "4px solid #fff",
    borderTop: "4px solid #fff",
  },
  marqueeText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  card: {
    background: "#fff",
    borderRadius: "25px",
    padding: "60px 40px",
    width: "90%",
    maxWidth: "700px",
    minHeight: "75vh",
    margin: "30px auto",
    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
    textAlign: "center",
  },
  buttonContainerVertical: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "25px",
    marginTop: "40px",
  },
  button: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    padding: "18px 30px",
    borderRadius: "12px",
    border: "none",
    width: "100%",
    maxWidth: "400px",
    transition: "all 0.3s ease",
  },
};

/* =======================
   MODAL STYLES
======================= */
const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "35px",
    borderRadius: "15px",
    width: "90%",
    maxWidth: "400px",
    textAlign: "center",
    boxShadow: "0 15px 30px rgba(0,0,0,0.3)",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
  },
  cancelBtn: {
    padding: "12px 25px",
    borderRadius: "10px",
    border: "none",
    fontWeight: "bold",
    background: "#6c757d",
    color: "white",
    cursor: "pointer",
  },
  confirmBtn: {
    padding: "12px 25px",
    borderRadius: "10px",
    border: "none",
    fontWeight: "bold",
    background: "linear-gradient(90deg, #d50000, #9b0000)",
    color: "white",
    cursor: "pointer",
  },
};

export default Fenmenu;
